class ProductFixedBar extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.createObserver(
      document.querySelector('[data-product-fixed-bar-external-el="button"]'),
      '0px',
    )
    this.createObserver(
      document.querySelector('[data-product-fixed-bar-external-el="title"]'),
      '-98px',
    )
  }

  setupListeners () {
    super.setupListeners()
  }

  setVisibility (visibility) {
    this.setAttribute('aria-hidden', visibility)

    visibility
      ? document.body.classList.add('util-FixedBar')
      : document.body.classList.remove('util-FixedBar')

    const footerEl = document.querySelector(
      '[data-product-fixed-bar-external-el="footer"]',
    )

    visibility
      ? footerEl.style.setProperty('--FixedBarHeight', `${this.offsetHeight}px`)
      : footerEl.style.setProperty('--FixedBarHeight', 0)
  }

  setTitleVisibility (visibility) {
    this.els.title.element.setAttribute('aria-hidden', visibility)
  }

  get shouldBeVisible () {
    const buttonEl = document.querySelector(
      '[data-product-fixed-bar-external-el="button"]',
    )

    if (!buttonEl) return

    const threshold =
      window.BAO.Utils.getOffsetTop(buttonEl) + buttonEl.offsetHeight

    return this.lastKnownY > threshold
  }

  intersectionCallback = entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (entry.target.tagName.toLowerCase().includes('button')) {
          this.setVisibility(true)
        } else {
          this.setTitleVisibility(true)
        }
      } else {
        if (entry.target.tagName.toLowerCase().includes('button')) {
          this.setVisibility(false)
        } else {
          this.setTitleVisibility(false)
        }
      }
    })
  }

  createObserver (el, root) {
    const options = {
      root: null,
      rootMargin: root,
      threshold: 0,
    }

    const observer = new IntersectionObserver(
      this.intersectionCallback,
      options,
    )
    observer.observe(el)
  }
}

if (!customElements.get('product-fixed-bar')) {
  customElements.define('product-fixed-bar', ProductFixedBar)
}
